export default {
  common: {
    search: '搜尋鞋款...',
    loading: '載入中...',
    welcome: '歡迎來到潮鞋電商',
    addToCart: '加入購物車',
    buyNow: '立即購買',
    outOfStock: '庫存不足',
    viewMore: '查看更多',
    relatedProducts: '相關商品',
    empty: '暫無資料',
    goBack: '返回',
    confirm: '確認',
    cancel: '取消',
    save: '儲存',
    delete: '刪除',
    edit: '編輯',
    success: '操作成功',
    error: '操作失敗',
  },
  // 這裡只放置特定需要手動優化的繁體翻譯
  // 不需要複製所有簡體中文的內容，因為會自動轉換
  nav: {
    home: '首頁',
    products: '所有商品',
    categories: '品類',
    brands: '品牌',
    collections: '系列',
    about: '關於我們',
    contact: '聯絡我們',
    account: '我的帳戶',
  },
  footer: {
    helpCenter: '幫助中心',
    aboutUs: '關於我們',
    contactUs: '聯絡我們',
    termsOfService: '服務條款',
    privacyPolicy: '隱私政策',
    copyright: '© 2023 潮鞋電商. 版權所有.'
  },
  home: {
    banner: {
      title: '探索最新鞋款',
      description: '發現您喜愛的潮流鞋款，展現個性風格',
      button: '瀏覽所有鞋子'
    },
    intro: {
      title: '關於我們的鞋子相冊',
      description1: '這是一個專注於展示潮流鞋款的相冊網站，您可以瀏覽各種品牌的鞋子圖片和詳情資訊。',
      description2: '我們提供高清圖片和詳盡的商品描述，讓您充分了解每一款鞋子的特點和風格。',
      button1: '瀏覽鞋子列表',
      button2: '按品牌分類瀏覽'
    },
    featured: {
      title: '精選品牌',
      description: '各大知名品牌的經典款式'
    }
  },
  shoes: {
    title: '鞋子相冊',
    searchPlaceholder: '搜尋鞋子名稱或型號...',
    filterByBrand: '按品牌篩選',
    sortBy: '排序方式',
    sortOptions: {
      newest: '最新添加',
      oldest: '添加時間（從早到晚）',
      nameAsc: '名稱 A-Z',
      nameDesc: '名稱 Z-A'
    },
    noResults: '沒有找到符合條件的鞋子',
    resetFilters: '重置篩選條件',
    viewDetails: '查看詳情',
    noModelNumber: '無型號',
    showing: '顯示',
    of: '共',
    pairs: '雙鞋子',
    page: '第',
    totalPages: '頁 / 共',
    pages: '頁',
    exclusivePhoto: '獨家實拍',
    brand: '品牌'
  },
  collections: {
    title: '品牌分類',
    subtitle: '瀏覽不同品牌的鞋子',
    error: '獲取品牌分類失敗',
    retry: '重試',
    empty: '暫無品牌分類數據',
    browse: '瀏覽鞋子'
  }
} 